// url过滤器 
export const urlFilter = (url, s) => {
	var baseUrl = 'https://files.sciconf.cn';
	if (!url) {
		url = 'https://files.sciconf.cn/mpweixin/dc1bd080-23e7-11eb-8a36-ebb87efcf8c0.jpg!wx360';
	} else if(url.indexOf('gif') != '-1') {
		//gif格式不加后缀
		return url;
	} else if (url.indexOf('wxfile:/') == -1) {
		url = url.replace('!avatar', '')
		url = url.replace('!wx250', '')
		if (url.indexOf('http') != -1) { // 全路径
			let ossFile = 'https://meetingfiles.oss-cn-qingdao.aliyuncs.com/';
			// 全路径拼接重复问题
			if(url.indexOf(ossFile + 'https') != -1){
				url = url.replace(ossFile,'');
			}else{
				url = url.indexOf(baseUrl) == -1 ? url : url + (s ? '!wx' + s : '');
			}
		} else if (url.indexOf('../') != -1) { // 本地图片
			url = url;
		} else if (url.indexOf('./') != -1) { // 相对路径
			url = baseUrl + url.replace('./', '') + (s ? '!wx' + s : '');
		} else { // 
			url = baseUrl + '/' + url + (s ? '!wx' + s : '');
		}
	}
	// 使用压缩图
	return url
}

export const Filter = {
    install(app){
       app.config.globalProperties.$urlFilter = urlFilter;
    }
}